import type { FiltersContext } from '@/components/providers/FiltersProvider/filters-provider.types';
import { createContext } from 'react';

export const filtersContext = createContext({} as FiltersContext);
